import { useQuery } from 'react-query';
import { getAllInProcess } from '../pages/Dashboard/dashboard-components/DashboardNotifications/notificationUtils';

export const useOpenProcesses = (accountId?: string) => {
  const enable = accountId !== undefined;
  const fetchFunction = () => getAllInProcess(accountId || '');
  return useQuery('open-processes', fetchFunction, { enabled: enable });
};
